/**
 * Reusable Instagram logo SVG with gradient, matching the existing
 * instagram-inbox components. Accepts a `className` prop so it
 * renders at whatever size the caller specifies via CSS.
 */
export function InstagramIcon({ className }: { className?: string }) {
    return (
        <svg viewBox="0 0 24 24" fill="none" className={className} aria-label="Instagram">
            <defs>
                <linearGradient id="ig-grad-shared" x1="0%" y1="100%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#f09433" />
                    <stop offset="25%" stopColor="#e6683c" />
                    <stop offset="50%" stopColor="#dc2743" />
                    <stop offset="75%" stopColor="#cc2366" />
                    <stop offset="100%" stopColor="#bc1888" />
                </linearGradient>
            </defs>
            <rect
                x="2" y="2" width="20" height="20" rx="5" ry="5"
                stroke="url(#ig-grad-shared)" strokeWidth="2" fill="none"
            />
            <circle
                cx="12" cy="12" r="4"
                stroke="url(#ig-grad-shared)" strokeWidth="2" fill="none"
            />
            <circle cx="17.5" cy="6.5" r="1.5" fill="url(#ig-grad-shared)" />
        </svg>
    );
}
